// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:51:07

export default {
  "id": "emoji-merge-fun-moji",
  "slug": "emoji-merge-fun-moji",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6ef2911146b74c9a88435a26c3adb067-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6ef2911146b74c9a88435a26c3adb067/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Emoji Merge Fun Moji",
      "description": "Welcome to Emoji Merge: Fun Moji! A fun and creative jigsaw puzzle that allows you to merge various funny emojis. Create super funny, super cute emoji combinations. It's not just a simple merger game and full of interesting challenges.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "challenge",
        "combine",
        "cute",
        "emojis"
      ]
    },
    "zh-CN": {
      "title": "表情合并乐趣",
      "description": "欢迎来到表情符号合并：趣味莫吉！一款有趣且富有创意的拼图游戏，让您合并各种有趣的表情符号。创建超级搞笑、超级可爱的表情符号组合。这不仅仅是一个简单的合并游戏，还充满了有趣的挑战。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "谜题"
      ],
      "tags": [
        "挑战",
        "组合",
        "可爱",
        "表情符号"
      ]
    },
    "zh-TW": {
      "title": "表情合體趣 Moji",
      "description": "歡迎來到表情圖標合體：趣味莫吉！一款有趣且創意的拼圖遊戲，讓您可以合體各種搞笑表情圖標。創造超級搞笑、超級可愛的表情圖標組合。這不只是一個簡單的合體遊戲，充滿了有趣的挑戰。",
      "instructions": "滑鼠點擊或滑動以開始遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "挑戰",
        "結合",
        "可愛",
        "表情圖片"
      ]
    },
    "zh-HK": {
      "title": "表情合拼趣",
      "description": "歡迎來到表情合拼：趣表情！一個好玩創意的拼圖遊戲，讓你合拼各種搞笑表情。創造超搞笑、超可愛的表情組合。這不只是簡單的合拼遊戲，還充滿有趣挑戰。",
      "instructions": "用滑鼠點擊或觸碰以遊玩",
      "genres": [
        "謎題"
      ],
      "tags": [
        "挑戰",
        "結合",
        "可愛",
        "表情圖片"
      ]
    },
    "ja": {
      "title": "絵文字マージ フンモジ",
      "description": "エモジ・マージ：楽しいモジへようこそ！面白くて創造的なパズルで、さまざまな面白いエモジを合体させることができます。超面白くて可愛いエモジの組み合わせを作成しましょう。単なる合体ゲームではなく、楽しい挑戦が満載です。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "挑戦",
        "組み合わせ",
        "可愛い",
        "絵文字"
      ]
    },
    "ko": {
      "title": "에모지 메이지 퍼프 무지",
      "description": "웰컴 투 엠조이 멀지: 펀 모지! 재미있고 창의적인 조각 퍼즐이며 다양한 유머러스 엠조이를 합치실 수 있습니다. 매우 유머러스하고 매우 귀여운 엠조이 조합을 만들어보세요. 단순한 합치기 게임이 아니라 다양한 도전 과제가 가득합니다.",
      "instructions": "마우스 클릭이나 탭하여 플레이하세요",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "챌린지",
        "결합",
        "귀여운",
        "이모티콘"
      ]
    },
    "fr": {
      "title": "Mélangez Fun Moji",
      "description": "Bienvenue dans Emoji Merge: Fun Moji ! Un puzzle-jigsaw amusant et créatif qui vous permet de fusionner divers emojis amusants. Créez des combinaisons d'emojis super drôles et super mignones. Ce n'est pas un simple jeu de fusion et il est plein de défis intéressants.",
      "instructions": "Clic ou appui de souris pour jouer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "défis",
        "combiner",
        "mignon",
        "émojis"
      ]
    }
  }
};
